import React from "react"
import { Checkbox, Spin, Tooltip } from 'antd'
import users from "@services/users"
import { alertPopup } from "@utils/popup"

class TopAgent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            top_agent: false,
            waiting: false
        }
    }

    componentDidMount() {
        this.setState({ top_agent: this.props.agentInfo.top_agent })
    }

    componentDidUpdate(prevProps) {
        if ((!prevProps.agentInfo || prevProps.agentInfo.top_agent === undefined) && this.props.agentInfo.top_agent !== undefined){
            this.setState({ top_agent: this.props.agentInfo.top_agent })
        }
    }

    handleTopAgentCheckbox = async (top_agent: any) => {
        this.setState({ waiting: true }, async () => {
            await users.updateTopAgent({ agent_id: this.props.agentId, top_agent: top_agent })
                    .then(() => {
                        this.setState({ top_agent: top_agent })
                    })
                    .catch(err => {
                        if (err) {
                            alertPopup({ type: 'error', title: 'שגיאה בעדכון סוכן נבחרת', body: '' })
                        }
                    })
                    .finally(() => this.setState({ waiting: false }))
        })
        
    }

    render () {

        const  { top_agent, waiting } = this.state

        return (
            <div style={{ display: 'flex' }}>
                
                <Tooltip title="סוכן המסומן בסימון זה יוצג ברשימת הסוכנים באתר">
                   
                        <span style={{ ...style.box, ...style.rightBox }}>
                            {waiting ? <Spin size='small'/> :
                                <Checkbox 
                                    onChange={(e) => this.handleTopAgentCheckbox(e.target.checked)}
                                    checked={top_agent ? true : false} />
                            }        
                        </span>
                </Tooltip>

                <span style={{ ...style.box, ...style.leftBox }}>
                    <span>{"סוכן נבחרת"}</span>
                </span>

            </div>
        )
    }
}

const style = {
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    rightBox: { cursor: 'pointer', borderRadius: '0 4px 4px 0' },
    leftBox: { cursor: 'pointer', borderRadius: '4px 0 0 4px' }
}

export default TopAgent